import { createFileRoute } from "@tanstack/react-router";
import { Panel } from "~/components/ui/page";
import { PaymentAccountsSettings } from "~/features/settings/payment-accounts";
import { SettingsIntro, SettingsSection } from "~/features/settings/section";
import { useT } from "~/lib/i18n";

export const Route = createFileRoute("/_app/settings/purchasing")({ component: PurchasingSettingsPage });

function PurchasingSettingsPage() {
  const t = useT();
  return (
    <>
      <SettingsIntro text={t("settings.pages.purchasing.subtitle")} />
      <Panel>
        <SettingsSection title={t("settings.paymentAccounts")} description={t("settings.paymentAccountsHint")}>
          <PaymentAccountsSettings />
        </SettingsSection>
      </Panel>
    </>
  );
}
